import React, { useState, useEffect } from 'react';
import axios from 'axios';
// import SideCalendar from '../../components/side-calendar/SideCalendar';
// import NoticeBoard from '../../components/notice-board/NoticeBoard';
import NoticeBoardSlide from '../../components/notice-board/NoticeBoardSlide';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';
import { Link } from 'react-router-dom';
import { Create } from './Components/Create';
import { View } from './Components/View';
import { Empty } from 'antd';
import ResponsiveBreadcrumb from '../../components/breadcrumb/ResponsiveBreadcrumb';
import { CalendarOutlined, FileTextOutlined, UserOutlined } from '@ant-design/icons';
import './Schedule.css';

export function SchoolCalendar(props) {
   // const navigate = useNavigate();

   const user_id = Utils.getCurrentUserInfo(Enums.UserInfo.id);
   const user_role = Utils.getCurrentUserInfo(Enums.UserInfo.role);

   const [currentDocument, setCurrentDocument] = useState(null);
   const [showView, setShowView] = useState(false);

   useEffect(() => {
      Utils.verifyJwt();

      if (['Super Admin', 'Admin', 'Teacher'].includes(user_role))
         getSchedule();
      else
         getScheduleStudent();
   }, []);

   const getSchedule = () => {
      const url = `${process.env.REACT_APP_API_SCHOOL_MANAGEMENT}/getschedule?type=school&level=-1&section=-1&uploader=${user_id}`;
      axios.get(url).then((response) => {
         if (response.data) {
            const data = response.data;
            setCurrentDocument(data.file_url);
            setShowView(true);
         }
      }, (error) => {
         console.log(error.message);
      });
   }

   const getScheduleStudent = () => {
      const url = `${process.env.REACT_APP_API_SCHOOL_MANAGEMENT}/getschedulestudent?type=school&id=${user_id}`;
      axios.get(url).then((response) => {
         if (response.data) {
            const data = response.data;
            setCurrentDocument(data.file_url);
            setShowView(true);
         }
      }, (error) => {
         console.log(error.message);
      });
   }

   const handleFinishUploading = (document) => {
      setCurrentDocument(null);
      setShowView(false);
      getSchedule();
   }

   return (
      <>
         <div className="dashboard-area-all schedule-page">
            <div className="dashboard-item schedule-shell">
               <div className="schedule-breadcrumb">
                  <ResponsiveBreadcrumb
                     items={[
                        { key: 'home', node: <Link to="/home">Home</Link> },
                        { key: 'schedule', node: 'Schedule' },
                        { key: 'school-calendar', node: 'School Calendar' },
                     ]}
                  />
               </div>
               <section className="schedule-overview">
                  <div>
                     <span className="schedule-kicker">Schedule</span>
                     <h1>School Calendar</h1>
                     <p>View the official school calendar and keep the latest schedule document available for the community.</p>
                     <div className="schedule-meta">
                        <span><CalendarOutlined /> School wide</span>
                        <span><UserOutlined /> {user_role}</span>
                     </div>
                  </div>
                  {(['Super Admin', 'Admin', 'Teacher'].includes(user_role)) &&
                     <div className="schedule-actions">
                        <Create
                           type='school'
                           level={-1}
                           button_label='School Calendar'
                           section={-1}
                           onFinishCreateCallback={handleFinishUploading}
                        />
                     </div>
                  }
               </section>

               <section className="schedule-panel">
                  <div className="schedule-panel-header">
                     <div>
                        <span className="schedule-kicker">Document</span>
                        <h2>Calendar File</h2>
                     </div>
                     <div className="schedule-meta" style={{ marginTop: 0 }}>
                        <span><FileTextOutlined /> {showView ? 'Available' : 'Not available'}</span>
                     </div>
                  </div>
                  {showView
                     ? <View
                        type='school'
                        uploader={user_id}
                        document={currentDocument}
                        showsearchtools={false}
                        emptydescription='School calendar not available.'
                     />
                     : <div className='schedule-empty'>
                        <Empty
                           description={'School calendar not available.'}
                           image="../images/brainee_mascot.png"
                        />
                     </div>
                  }
               </section>
            </div>
         </div >
         {/* <div className="notice-area">
            <div className="notice-item">
               <SideCalendar />
               <NoticeBoard />
            </div>
         </div> */}

      </>
   );
}
